import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import "./addrequest.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AddRequest = ({ logout, user, API_URL }) => {
    const navigate = useNavigate();

    // ─── Номер заказа (берётся с SQL) ─────────────────────────────
    const [orderNumber, setOrderNumber] = useState(null);

    // ─── Тип заявки ───────────────────────────────────────────────
    const [typerequest, setTyperequest] = useState(null);
    const isShare = typerequest?.value === "sharetour";

    // ─── Заказчик (только для "partners") ─────────────────────────
    const [comp, setComp] = useState(null);           // Select — компания
    // Тур оператор ПАРТНЁРА (внешний, вводится вручную — только в partners)
    const [tourOperator, setTourOperator] = useState("");
    const [customerContacts, setCustomerContacts] = useState("");
    const [groupNumber, setGroupNumber] = useState("");

    // ─── Контактная информация гостей ─────────────────────────────
    // sharetour — 4 гостя (каждый со своим местом/временем выезда и высадки),
    // остальные — 1 гость
    const [guests, setGuests] = useState([{ name: "", contacts: "" }]);

    const updateGuest = (index, field, value) => {
        const arr = [...guests];
        arr[index][field] = value;
        setGuests(arr);
    };

    // ─── Программа тура ───────────────────────────────────────────
    const [tour, setTour] = useState(null);           // Select — тур
    const [dateStart, setDateStart] = useState("");
    const [dateEnd, setDateEnd] = useState("");
    const [participantsCount, setParticipantsCount] = useState("");
    const [needsYurt, setNeedsYurt] = useState({ value: false, label: "Нет" });
    const [yurtComment, setYurtComment] = useState("");
    // ─── Логистика (для individual/partners — общая на всю заявку) ─
    const [departurePlace, setDeparturePlace] = useState("");
    const [departureTime, setDepartureTime] = useState("");
    const [arrivalPlace, setArrivalPlace] = useState("");
    const [transportType, setTransportType] = useState(""); // toyota | sedan | minivan | bus
    const [guid, setGuid] = useState({ value: false, label: "Нет" });           // Select — гид
    const [guidlang, setGuidlang] = useState("");
    const [museum, setMuseum] = useState("");
    const [extraLocation, setExtraLocation] = useState("");

    // ─── Тип питания ──────────────────────────────────────────────
    const [foodStandard, setFoodStandard] = useState("");
    const [foodVegan, setFoodVegan] = useState("");
    const [foodOther, setFoodOther] = useState("");

    // ─── Стоимость услуг ──────────────────────────────────────────
    const [services, setServices] = useState([
        { title: "Машина", qty: "", price: "" },
        { title: "Питание", qty: "", price: "" },
        { title: "Проживание", qty: "", price: "" },
        { title: "Гид", qty: "", price: "" },
        { title: "Входные билеты", qty: "", price: "" },
    ]);
    const [items, setItems] = useState([]);           // доп. статьи
    const [peopleCount, setPeopleCount] = useState("");

    // ─── Тип оплаты ───────────────────────────────────────────────
    const [paymentType, setPaymentType] = useState("cash"); // cash | transfer
    const [paymentByDate, setPaymentByDate] = useState(false);
    const [paymentDate, setPaymentDate] = useState("");

    // ─── Комментарий ──────────────────────────────────────────────
    const [comment, setComment] = useState("");

    // ─── Проверка обязательных полей (*) ───────────────────────────
    // После первой попытки «Добавить» пустые обязательные поля подсвечиваются красным
    // и подсветка сама снимается, как только поле заполнено.
    const [submitted, setSubmitted] = useState(false);
    const [saving, setSaving] = useState(false);

    // ─── Данные с сервера ─────────────────────────────────────────
    const [tours, setTours] = useState([]);
    const [company, setCompany] = useState([]);

    useEffect(() => {
        const getTours = async () => { const r = await axios.post(`${API_URL}/getTours`); setTours(r.data); };
        const getCompany = async () => { const r = await axios.post(`${API_URL}/getCompany`); setCompany(r.data); };
        // следующий номер заказа из БД
        const getNextNumber = async () => {
            try {
                const r = await axios.post(`${API_URL}/getNextOrderNumber`);
                setOrderNumber(r.data.next);
            } catch (e) { console.error("Не удалось получить номер заказа:", e); }
        };
        getTours(); getCompany(); getNextNumber();
    }, []);


    // ─── Опции для Select ─────────────────────────────────────────
    const optionsCompany = company.map((i) => ({ value: i.name, label: i.name }));
    const optionsTours = tours.map((i) => ({ value: i.name, label: i.name }));
    const optionsGuide = [
        { value: true, label: "Да" },
        { value: false, label: "Нет" },
    ];
    const optionsNeedsYurt = [
        { value: true, label: "Да" },
        { value: false, label: "Нет" },
    ];
    const optionsGuideLang = [
        { value: "eng", label: "Английский" },
        { value: "rus", label: "Русский" },
        { value: "uz", label: "Узбекский" },
        { value: "itl", label: "Итальянский" },
        { value: "fra", label: "Французский" },
        { value: "deu", label: "Немецкий" },
        { value: "spa", label: "Испанский" },
        { value: "tur", label: "Турецкий" },
        { value: "chn", label: "Китайский" },
        { value: "jpn", label: "Японский" },
        { value: "kor", label: "Корейский" },
        { value: "ara", label: "Арабский" },
        { value: "hin", label: "Хинди" },
        { value: "per", label: "Персидский" },
        { value: "kaz", label: "Казахский" },
        { value: "taj", label: "Таджикский" },
    ];
    const optionsTyperequest = [
        { value: "individual", label: "Индивидуальный" },
        { value: "sharetour", label: "Совместный" },
        { value: "partners", label: "Партнеры" },
    ];


    // ─── Подсчёт итогов ───────────────────────────────────────────
    const servicesTotal = services.reduce((s, i) => s + Number(i.qty || 0) * Number(i.price || 0), 0);
    const extraTotal = items.reduce((s, i) => s + Number(i.qty || 0) * Number(i.price || 0), 0);
    const grandTotal = servicesTotal + extraTotal;

    // ─── Хелперы ──────────────────────────────────────────────────
    const updateService = (index, field, value) => {
        const arr = [...services];
        arr[index][field] = value;
        setServices(arr);
    };

    const addItem = () => {
        setItems([...items, { title: "", qty: "", price: "" }]);
    };

    const updateItem = (index, field, value) => {
        const arr = [...items];
        arr[index][field] = value;
        setItems(arr);
    };

    // ─── Стили для всех Select (общий объект) ─────────────────────
    const selectStyles = (dark = false) => ({
        control: (base, state) => ({
            ...base,
            backgroundColor: dark ? "#1d2547" : "#fff",
            width: dark ? "300px" : "100%",
            border: state.isFocused ? "2px solid #4f7cff" : "2px solid gray",
            borderRadius: "10px",
            padding: "5px",
            boxShadow: "none",
            cursor: "pointer",
            "&:hover": { border: "2px solid #4f7cff" },
        }),
        singleValue: (base) => ({ ...base, color: dark ? "#fff" : "#1d2547" }),
        placeholder: (base) => ({ ...base, color: "#aaa" }),
        menu: (base) => ({ ...base, backgroundColor: "#fff", borderRadius: "10px", padding: "10px", overflow: "hidden" }),
        option: (base, state) => ({
            ...base,
            borderRadius: "10px",
            backgroundColor: state.isSelected || state.isFocused ? "#1d2547" : "#fff",
            color: state.isSelected || state.isFocused ? "#fff" : "#1d2547",
            cursor: "pointer",
            transition: "0.15s",
        }),
        input: (base) => ({ ...base, color: dark ? "#fff" : "#1d2547" }),
    });

    // Возвращает { ключ_поля: "текст ошибки" } — пустой объект, если всё заполнено
    const validate = () => {
        const e = {};
        const empty = (v) => !String(v ?? "").trim();
        const type = typerequest?.value;

        if (!type) { e.type = "Выберите тип заявки"; return e; }

        // Заказчик — только партнёры
        if (type === "partners") {
            if (!comp) e.company = "Выберите заказчика";
            if (empty(tourOperator)) e.tourOperator = "Укажите тур оператора";
            if (empty(customerContacts)) e.customerContacts = "Укажите контакты заказчика";
        }

        // Гости: первый гость обязателен всегда. В совместном туре (4 места)
        // остальные места можно оставить пустыми, но если место начали заполнять —
        // нужны и имя, и контакты.
        guests.forEach((g, i) => {
            const touched = !empty(g.name) || !empty(g.contacts);
            if (i === 0 || touched) {
                if (empty(g.name)) e[`guest-${i}-name`] = `Укажите имя гостя${guests.length > 1 ? ` ${i + 1}` : ""}`;
                if (empty(g.contacts)) e[`guest-${i}-contacts`] = `Укажите контакты гостя${guests.length > 1 ? ` ${i + 1}` : ""}`;
            }
        });

        // Программа тура
        if (!tour) e.tour = "Выберите программу тура";
        if (!dateStart) e.dateStart = "Укажите дату начала";
        if (!dateEnd) e.dateEnd = "Укажите дату окончания";
        else if (dateStart && dateEnd < dateStart) e.dateEnd = "Дата окончания раньше даты начала";
        if (!(Number(participantsCount) > 0)) e.participants = "Укажите количество участников";

        // Логистика
        if (!transportType) e.transport = "Выберите тип транспорта";
        if (!guid) e.guide = "Укажите, нужен ли гид";

        // Стоимость: сумма должна быть больше нуля, у доп. статей с суммой — название
        if (!(grandTotal > 0)) e.services = "Заполните стоимость услуг — итог не может быть $0";
        items.forEach((it, i) => {
            const hasSum = (Number(it.qty) || 0) * (Number(it.price) || 0) > 0;
            if (hasSum && empty(it.title)) e[`item-${i}`] = `Укажите название доп. статьи ${i + 1}`;
        });

        // Оплата по дате — без даты смысла нет
        if (paymentType === "cash" && paymentByDate && !paymentDate) e.paymentDate = "Укажите дату оплаты";

        return e;
    };

    const errors = submitted ? validate() : {};
    const errCls = (key) => (errors[key] ? " addrequest-field-error" : "");
    const errText = (key) => (errors[key] ? <small className="addrequest-error-text">{errors[key]}</small> : null);

    // ─── Сборка данных для отправки в БД ──────────────────────────
    const handleSubmit = async () => {
        if (saving) return;
        setSubmitted(true);
        const found = validate();
        const keys = Object.keys(found);
        if (keys.length) {
            toast.error(keys.length === 1 ? found[keys[0]] : `${found[keys[0]]} (и ещё ${keys.length - 1})`);
            // прокрутка к первому незаполненному полю
            setTimeout(() => {
                document.querySelector(".addrequest-field-error")?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 50);
            return;
        }

        const type = typerequest?.value;

        const payload = {
            type,
            orderNumber,                       // номер из БД (бэкенд всё равно подтвердит/перезапишет)

            // Заказчик
            company: comp?.value || null,
            manager: user?.fullname || null,   // наш оператор — кто создал заявку
            tourOperator,                      // тур оператор ПАРТНЁРА (только partners)
            customerContacts,
            groupNumber,

            // Гости (для sharetour включают пер-гостевую логистику)
            guests: guests.map((g) =>
                isShare
                    ? {
                        name: g.name,
                        contacts: g.contacts,
                        departurePlace: g.departurePlace || "",
                        departureTime: g.departureTime || "",
                        arrivalPlace: g.arrivalPlace || "",
                    }
                    : { name: g.name, contacts: g.contacts }
            ),

            // Тур
            tour: tour?.value || null,
            dateStart,
            dateEnd,
            participantsCount: Number(participantsCount) || 0,

            // Логистика (общая) — только для individual/partners
            departurePlace: isShare ? null : departurePlace,
            departureTime: isShare ? null : departureTime,
            arrivalPlace: isShare ? null : arrivalPlace,
            transportType,
            guideType: guid?.value || null,
            guideLang: guidlang?.value || null,
            museum,
            extraLocation,
            needsYurt: needsYurt.value,
            yurtComment: needsYurt.value ? yurtComment : null,

            // Питание
            food: {
                standard: Number(foodStandard) || 0,
                vegan: Number(foodVegan) || 0,
                other: Number(foodOther) || 0,
            },

            // Стоимость
            services: services.map((s) => ({
                title: s.title,
                qty: Number(s.qty) || 0,
                price: Number(s.price) || 0,
                total: (Number(s.qty) || 0) * (Number(s.price) || 0),
            })),
            extraItems: items.map((i) => ({
                title: i.title,
                qty: Number(i.qty) || 0,
                price: Number(i.price) || 0,
                total: (Number(i.qty) || 0) * (Number(i.price) || 0),
            })),
            peopleCount: Number(peopleCount) || 0,
            grandTotal,
            paymentType,
            paymentByDate,
            paymentDate: paymentByDate ? paymentDate : null,

            // Комментарий
            comment,
        };

        setSaving(true);
        try {
            // единый эндпоинт — бэкенд сам кладёт в нужную таблицу по type
            await axios.post(`${API_URL}/addRequest`, payload);
            toast.success("Заявка успешно добавлена");
            navigate(-1);
        } catch (err) {
            console.error("Ошибка при сохранении:", err);
            toast.error("Не удалось сохранить заявку");
        } finally {
            setSaving(false);
        }
    };

    // ─── Блок «Заказчик» (только для partners) ────────────────────
    const renderCustomerBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-regular fa-user"></i>
                <h2>Заказчик</h2>
            </div>
            <div className="addrequest-input-flex">
                <div className={`addrequest-input-box${errCls("company")}`}>
                    <label>Имя Заказчика *</label>
                    <label style={{ width: "100%" }}>
                        <Select
                            options={optionsCompany}
                            isClearable
                            value={comp}
                            onChange={setComp}
                            placeholder="Выберите компанию"
                            styles={selectStyles()}
                        />
                    </label>
                    {errText("company")}
                </div>
                <div className={`addrequest-input-box${errCls("tourOperator")}`}>
                    <label>Тур оператор *</label>
                    {/* тур оператор партнёра — вводится вручную */}
                    <input type="text" value={tourOperator} onChange={(e) => setTourOperator(e.target.value)} />
                    {errText("tourOperator")}
                </div>
                <div className={`addrequest-input-box${errCls("customerContacts")}`}>
                    <label>Контакты (Почта / Телефон) *</label>
                    <input type="text" value={customerContacts} onChange={(e) => setCustomerContacts(e.target.value)} />
                    {errText("customerContacts")}
                </div>
                <div className="addrequest-input-box">
                    <label>Номер группы</label>
                    <input type="text" value={groupNumber} onChange={(e) => setGroupNumber(e.target.value)} />
                </div>
            </div>
        </div>
    );

    // ─── Контактная информация гостя(ей) ──────────────────────────
    // для sharetour добавляются поля «место/время выезда» и «место высадки»
    const renderGuestBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-regular fa-address-card"></i>
                <h2>Контактная информация гостя</h2>
            </div>
            {guests.map((guest, index) => (
                <div className="addrequest-input-flex" key={index}>
                    {guests.length > 1 && (
                        <div style={{ width: "100%", padding: "4px 0 2px" }}>
                            <label style={{ fontWeight: 600, color: "#1d2547" }}>
                                Гость {index + 1}
                            </label>
                        </div>
                    )}
                    <div className={`addrequest-input-box${errCls(`guest-${index}-name`)}`}>
                        <label>Имя гостя {index === 0 ? "*" : ""}</label>
                        <input
                            type="text"
                            value={guest.name}
                            onChange={(e) => updateGuest(index, "name", e.target.value)}
                        />
                        {errText(`guest-${index}-name`)}
                    </div>
                    <div className={`addrequest-input-box${errCls(`guest-${index}-contacts`)}`}>
                        <label>Контакты (Почта / Телефон) {index === 0 ? "*" : ""}</label>
                        <input
                            type="text"
                            value={guest.contacts}
                            onChange={(e) => updateGuest(index, "contacts", e.target.value)}
                        />
                        {errText(`guest-${index}-contacts`)}
                    </div>

                    {/* Пер-гостевая логистика — только для совместного тура */}
                    {isShare && (
                        <>
                            <div className="addrequest-input-box">
                                <label>Место выезда</label>
                                <input
                                    type="text"
                                    value={guest.departurePlace || ""}
                                    onChange={(e) => updateGuest(index, "departurePlace", e.target.value)}
                                />
                            </div>
                            <div className="addrequest-input-box">
                                <label>Время выезда</label>
                                <input
                                    type="time"
                                    value={guest.departureTime || ""}
                                    onChange={(e) => updateGuest(index, "departureTime", e.target.value)}
                                />
                            </div>
                            <div className="addrequest-input-box">
                                <label>Место высадки</label>
                                <input
                                    type="text"
                                    value={guest.arrivalPlace || ""}
                                    onChange={(e) => updateGuest(index, "arrivalPlace", e.target.value)}
                                />
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    );

    const renderTourBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-location-dot"></i>
                <h2>Программа тура</h2>
            </div>
            <div className="addrequest-input-flex">
                <div className={`addrequest-input-box${errCls("tour")}`}>
                    <label>Программа *</label>
                    <label style={{ width: "100%" }}>
                        <Select
                            options={optionsTours}
                            isClearable
                            value={tour}
                            onChange={setTour}
                            placeholder="Выберите тур"
                            styles={selectStyles()}
                        />
                    </label>
                    {errText("tour")}
                </div>
                <div className={`addrequest-input-box${errCls("dateStart")}`}>
                    <label>Дата начала *</label>
                    <input type="date" value={dateStart} onChange={(e) => setDateStart(e.target.value)} />
                    {errText("dateStart")}
                </div>
                <div className={`addrequest-input-box${errCls("dateEnd")}`}>
                    <label>Дата окончания *</label>
                    <input type="date" value={dateEnd} min={dateStart || undefined} onChange={(e) => setDateEnd(e.target.value)} />
                    {errText("dateEnd")}
                </div>
                <div className={`addrequest-input-box${errCls("participants")}`}>
                    <label>Количество участников *</label>
                    <input type="number" min="1" value={participantsCount} onChange={(e) => setParticipantsCount(e.target.value)} />
                    {errText("participants")}
                </div>
                <div className="addrequest-input-box">
                    <label>Размещение в юрте</label>
                    <label style={{ width: "100%" }}>
                        <Select
                            options={optionsNeedsYurt}
                            value={needsYurt}
                            onChange={setNeedsYurt}
                            placeholder="Нужна юрта?"
                            styles={selectStyles()}
                        />
                    </label>
                </div>

                {needsYurt.value && (
                    <div className="addrequest-input-box">
                        <label>Комментарий для юрты</label>
                        <input
                            type="text"
                            value={yurtComment}
                            onChange={(e) => setYurtComment(e.target.value)}
                        />
                    </div>
                )}
            </div>
        </div>
    );

    const renderLogisticsBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-train"></i>
                <h2>Логистика</h2>
            </div>

            {/* Общие место/время выезда и высадки — НЕ для sharetour
                (там эти поля заданы для каждого гостя отдельно) */}
            {!isShare && (
                <div className="addrequest-input-flex">
                    <div className="addrequest-input-box">
                        <label>Место выезда</label>
                        <input type="text" value={departurePlace} onChange={(e) => setDeparturePlace(e.target.value)} />
                    </div>
                    <div className="addrequest-input-box">
                        <label>Время выезда</label>
                        <input type="time" value={departureTime} onChange={(e) => setDepartureTime(e.target.value)} />
                    </div>
                    <div className="addrequest-input-box">
                        <label>Место высадки</label>
                        <input type="text" value={arrivalPlace} onChange={(e) => setArrivalPlace(e.target.value)} />
                    </div>
                </div>
            )}

            <div className="addrequest-input-flex-select-car">
                <div className={`addrequest-input-box${errCls("transport")}`}>
                    <label>Тип транспорта *</label>
                    <span>
                        {[
                            { key: "4x4", icon: "fa-truck-monster", label: "4x4" },
                            { key: "sedan", icon: "fa-car", label: "Sedan" },
                            { key: "minivan", icon: "fa-van-shuttle", label: "Minivan" },
                            { key: "bus", icon: "fa-bus-side", label: "Bus" },
                            { key: "none", icon: "fa-solid fa-square-xmark", label: "Без машины" },
                        ].map((t) => (
                            <button
                                key={t.key}
                                type="button"
                                className={`addrequest-input-flex-select-car-btn${transportType === t.key ? " active" : ""}`}
                                onClick={() => setTransportType(t.key)}
                            >
                                <i className={`fa-solid ${t.icon}`}></i>
                                {t.label}
                            </button>
                        ))}
                    </span>
                    {errText("transport")}
                </div>
            </div>

            <div className="addrequest-input-flex">
                <div className={`addrequest-input-box${errCls("guide")}`}>
                    <label>Тур Гид *</label>
                    <label style={{ width: "100%" }}>
                        <Select
                            options={optionsGuide}
                            value={guid}
                            isClearable
                            onChange={setGuid}
                            placeholder="Выберите гид"
                            styles={selectStyles()}
                        />
                    </label>
                    {errText("guide")}
                </div>
                {guid?.value === true && (
                    <div className="addrequest-input-box">
                        <label>Язык гида</label>
                        <label style={{ width: "100%" }}>
                            <Select
                                options={optionsGuideLang}
                                value={guidlang}
                                isClearable
                                onChange={setGuidlang}
                                placeholder="Выберите язык"
                                styles={selectStyles()}
                            />
                        </label>
                    </div>
                )}

                <div className="addrequest-input-box">
                    <label>Музей</label>
                    <input type="text" value={museum} onChange={(e) => setMuseum(e.target.value)} />
                </div>
                <div className="addrequest-input-box">
                    <label>Доп. Локация</label>
                    <input type="text" value={extraLocation} onChange={(e) => setExtraLocation(e.target.value)} />
                </div>
            </div>

            <div className="addrequest-input-flex selectcafe">
                <div className="addrequest-input-box">
                    <label>Тип питания</label>
                    <table className="addrequest-input-flex-edit-eat">
                        <tbody>
                            <tr>
                                <th>ТИП</th>
                                <th><i className="fa-solid fa-utensils"></i> Стандарт</th>
                                <th><i className="fa-solid fa-carrot"></i> Веган</th>
                                <th><i className="fa-brands fa-creative-commons-nd"></i> Другое</th>
                            </tr>
                            <tr>
                                <th>Количество человек</th>
                                <td><input type="number" value={foodStandard} onChange={(e) => setFoodStandard(e.target.value)} /></td>
                                <td><input type="number" value={foodVegan} onChange={(e) => setFoodVegan(e.target.value)} /></td>
                                <td><input type="number" value={foodOther} onChange={(e) => setFoodOther(e.target.value)} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );

    const renderPriceBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-circle-dollar-to-slot"></i>
                <h2>Детали - Стоимость услуг *</h2>
            </div>
            <div className={`addrequest-input-flex-price-summary${errCls("services")}`}>
                <table>
                    <thead>
                        <tr>
                            <th>Статья</th>
                            <th>Кол-во</th>
                            <th>Цена / ед.</th>
                            <th>Итого</th>
                        </tr>
                    </thead>
                    <tbody>
                        {services.map((service, index) => (
                            <tr key={index}>
                                <td>{service.title}</td>
                                <td>
                                    <input
                                        type="number" placeholder="0"
                                        value={service.qty}
                                        onChange={(e) => updateService(index, "qty", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number" placeholder="$0"
                                        value={service.price}
                                        onChange={(e) => updateService(index, "price", e.target.value)}
                                    />
                                </td>
                                <td className="total-price">
                                    ${(Number(service.qty) || 0) * (Number(service.price) || 0)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index} className={errCls(`item-${index}`).trim()}>
                                <td>
                                    <input
                                        type="text" placeholder="Название"
                                        value={item.title}
                                        onChange={(e) => updateItem(index, "title", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number" placeholder="0"
                                        value={item.qty}
                                        onChange={(e) => updateItem(index, "qty", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number" placeholder="$0"
                                        value={item.price}
                                        onChange={(e) => updateItem(index, "price", e.target.value)}
                                    />
                                </td>
                                <td>
                                    ${(Number(item.qty) || 0) * (Number(item.price) || 0)}
                                    <button
                                        className="deleteitems" type="button"
                                        onClick={() => setItems(items.filter((_, i) => i !== index))}
                                    >✕</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="4">
                                <button type="button" onClick={addItem} className="add-article-btn">
                                    + Добавить статью ({items.length})
                                </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {errText("services")}
            {items.map((_, i) => <React.Fragment key={i}>{errText(`item-${i}`)}</React.Fragment>)}
            <div className="addrequest-box-info-panel-down">
                <h5>Итого с клиента</h5>
                <h4>${grandTotal.toLocaleString()}</h4>
            </div>
        </div>
    );

    const renderPaymentBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-credit-card"></i>
                <h2>Тип оплаты *</h2>
            </div>
            <div className="addrequest-input-flex-type-cash">
                {[
                    { key: "cash", icon: "fa-money-bill", label: "Наличка" },
                    { key: "transfer", icon: "fa-building-columns", label: "Перечисление" },
                ].map((p) => (
                    <button
                        key={p.key}
                        type="button"
                        className={paymentType === p.key ? "active" : ""}
                        onClick={() => setPaymentType(p.key)}
                    >
                        <i className={`fa-solid ${p.icon}`}></i>
                        {p.label}
                    </button>
                ))}
            </div>

            {paymentType === "cash" && (
                <div className="addrequest-input-flex">
                    <div className="addrequest-input-box">
                        <label style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer" }}>
                            <input
                                type="checkbox"
                                checked={paymentByDate}
                                onChange={(e) => setPaymentByDate(e.target.checked)}
                                className="checkbox"
                            />
                            Оплата по дате
                        </label>
                    </div>

                    {paymentByDate && (
                        <div className={`addrequest-input-box${errCls("paymentDate")}`}>
                            <label>Дата оплаты *</label>
                            <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                            {errText("paymentDate")}
                        </div>
                    )}
                </div>
            )}
        </div>
    );

    const renderCommentBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-comment-dots"></i>
                <h2>Дополнительные комментарии</h2>
            </div>
            <div className="addrequest-input-flex">
                <div className="addrequest-input-box">
                    <textarea
                        placeholder="Особые пожелания, заметки, детали по питанию или трансферу."
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </div>
            </div>
        </div>
    );

    // ─── Рендер формы по типу ─────────────────────────────────────
    const renderForm = () => {
        if (!typerequest) return null;

        return (
            <>
                {typerequest.value === "partners" && renderCustomerBlock()}
                {renderGuestBlock()}
                {renderTourBlock()}
                {renderLogisticsBlock()}
                {renderPriceBlock()}
                {renderPaymentBlock()}
                {renderCommentBlock()}
            </>
        );
    };

    // ─── JSX ──────────────────────────────────────────────────────
    return (
        <div className="addrequest">
            <div className="addrequest-flex">
                <div className="addrequest-box1">
                    <div className="addrequest-box1-info">
                        Заказ №{orderNumber ?? "…"}
                    </div>
                    <div className="addrequest-box1-type-tour">
                        <Select
                            options={optionsTyperequest}
                            value={typerequest}
                            isClearable
                            onChange={(val) => {
                                setTyperequest(val);
                                // sharetour — 4 гостя (с пер-гостевой логистикой), остальные — 1
                                if (val?.value === "sharetour") {
                                    setGuests(Array.from({ length: 4 }, () => ({
                                        name: "", contacts: "",
                                        departurePlace: "", departureTime: "", arrivalPlace: "",
                                    })));
                                } else {
                                    setGuests([{ name: "", contacts: "" }]);
                                }
                            }}
                            placeholder="Выберите тип"
                            styles={selectStyles(true)}
                        />
                    </div>
                    <div className="addrequest-box1-btn">
                        <button type="button" onClick={() => navigate(-1)}>Отмена</button>
                        <button type="button" onClick={handleSubmit} disabled={saving}>{saving ? "Сохраняем…" : "Добавить"}</button>
                    </div>
                </div>

                {renderForm()}
            </div>
        </div>
    );
};

export default AddRequest;